import { withRouter } from 'react-router-dom';
import { ActionCreators } from 'redux-undo';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import ErrorBoundary from './error-boundary';
import errorActions from '../actions';

const mapDispatchToProps = (dispatch) => ({
  setErrorState(status) {
    dispatch(errorActions.setErrorState(status));
  },
  undoProgress() {
    dispatch(ActionCreators.undo());
    toast.success('Undo saved');
  }
});

const mapStateToProps = (state) => ({
  hasError: state.errors.hasError
});

const ConnectedErrorBoundary = withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary));

export default ConnectedErrorBoundary;